import { ReactComponent as NotificationSentSvg } from "../../assets/images/svgs/notificationSent.svg";

const NotificationSentIcon = ({ className = "", ...props }) => {
  return (
    <NotificationSentSvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default NotificationSentIcon;
